import { inject, Injectable } from '@angular/core';

import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class MaintenanceApiService {
    private api: ApiService = inject(ApiService);

    public getMaintenances = this.api.getFetcher().path('/maintenances').method('get').create();
}
